const semanticClassNames = {
    inputContainer: 'checkbox__input-container',
};
export default semanticClassNames;
//# sourceMappingURL=Checkbox.semanticClassNames.js.map